/**
 * ========================================
 * CHATBOT UI MODULE
 * Handles DOM creation and basic UI manipulations
 * ========================================
 */
(function () {
  'use strict';

  function createWidgetHTML() {
    const logoUrl = window.CODESKIN_LOGO_URL || '';
    const welcomeVideoUrl = window.WELCOME_VIDEO_URL || '';
    const welcomeCaptionsUrl = window.WELCOME_VIDEO_CAPTIONS_URL || '';
    const faceScanVideoUrl = window.FACESCAN_VIDEO_URL || '';
    const resultsVideoUrl = window.RESULTS_VIDEO_URL || '';
    const termsUrl = window.TERMS_URL || '/policies/terms-of-service';
    const privacyUrl = window.PRIVACY_URL || '/policies/privacy-policy';
    const scannerPrivacyUrl = window.SKIN_SCANNER_PRIVACY_URL || '/pages/skin-scanner-privacy-policy';
    const welcomeTrackHtml = welcomeCaptionsUrl
      ? '<track kind="captions" label="English" srclang="en" src="' + welcomeCaptionsUrl + '" default>'
      : '';

    return `
      <div id="chatbot-box">
        <div id="chatbot-header">
          <div id="chatbot-header-title">
            <span>Codeskin</span>
          </div>
          <div id="chatbot-header-actions">
            <button id="chatbot-view-results-header" style="display: none;" class="header-action-btn">View Results</button>
            <span id="chatbot-close" title="Close">✕</span>
          </div>
        </div>

        <div id="chatbot-content-container">
          <div id="chatbot-main-panel">
            <div id="chatbot-welcome" class="chatbot-view-fade" style="display: none;">
              <video id="welcome-video-player" class="welcome-video welcome-video-element" playsinline>
                <source src="${welcomeVideoUrl}" type="video/mp4">
                ${welcomeTrackHtml}
                Your browser does not support the video tag.
              </video>
              <button id="welcome-video-mute-toggle" class="welcome-btn secondary" type="button" style="display:none; margin: 8px auto 0 auto;">Mute</button>
              <p class="welcome-text-codi" id="welcome-video-captions-line" aria-live="polite" aria-atomic="true"></p>
              <div class="welcome-buttons">
                <button class="welcome-btn primary orange-btn" id="start-questionnaire-btn">
                  Start Now
                </button>
                <button class="welcome-btn primary" id="retake-test-welcome-btn" style="display: none;">
                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="margin-right: 6px;">
                    <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58 4 4.01 7.58 4.01 12C4.01 16.42 7.58 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z" fill="white"/>
                  </svg>
                  Retake Test
                </button>
                <button class="welcome-btn secondary" id="view-analysis-btn" style="display: none;">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="margin-right: 6px;">
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
                  </svg>
                  View Skin Analysis
                </button>
              </div>
            </div>

            <div id="chatbot-questionnaire" style="display: none;" class="chatbot-view-fade">
              <div id="questionnaire-progress">
                <div id="progress-bar">
                  <div id="progress-fill"></div>
                </div>
                <div id="progress-text">Question <span id="current-question">1</span> of <span id="total-questions">9</span></div>
              </div>
              <div id="questionnaire-content"></div>

              <div id="questionnaire-navigation">
                <button id="prev-question-btn">Previous</button>
                <button id="chatbot-back-to-results" style="display: none;" class="link-btn">Back to Results</button>
                <button id="next-question-btn" disabled>Next</button>
              </div>
            </div>

            <div id="chatbot-face-scan" style="display: none;" class="chatbot-view-fade">
              <div class="face-scan-container">
                <!-- Selection State (Initial) -->
                <div id="face-scan-selection" class="face-scan-step active">
                  <div class="face-scan-header">
                    <video id="face-scan-video-player" class="face-scan-video-element" playsinline autoplay>
                      <source src="${faceScanVideoUrl}">
                    </video>
                    <button id="face-scan-video-mute-toggle" class="welcome-btn secondary" type="button" style="display:none; margin: 8px auto 0 auto;">Mute</button>
                    <p>Get personalized recommendations with our advanced <strong>AI Skin Analysis</strong>. Choose how you'd like to provide your photo.</p>
                  </div>

                  <!-- Unified Action Group -->
                  <div class="face-scan-actions-group">
                    <!-- Mandatory Terms & Privacy Policy Consent Checkbox Card -->
                    <div class="face-scan-consent-wrapper" id="face-scan-consent-wrapper">
                      <label class="face-scan-consent-label" for="face-scan-consent-checkbox">
                        <span class="face-scan-custom-checkbox-wrap">
                          <input type="checkbox" id="face-scan-consent-checkbox" class="face-scan-consent-checkbox" name="face_scan_consent">
                          <span class="face-scan-checkbox-custom" aria-hidden="true">
                            <svg viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.5 5L4.5 8L10.5 2" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                        </span>
                        <span class="face-scan-consent-text">
                          I read &amp; agree to the <a href="https://codeskin.in/pages/skin-scanner-privacy-policy" target="_blank" rel="noopener" id="open-face-scan-policy-btn" class="face-scan-link-btn">privacy policy</a>.
                        </span>
                      </label>
                      <div class="face-scan-consent-error" id="face-scan-consent-error" style="display: none;">
                        Please agree to the terms &amp; conditions and privacy policy before taking or uploading a face scan.
                      </div>
                    </div>
                    
                    <!-- Buttons Container -->
                    <div class="welcome-buttons side-by-side-buttons" id="face-scan-buttons-wrap">
                      <button id="start-camera-btn" class="welcome-btn primary consent-disabled" disabled type="button">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" style="margin-right: 6px;">
                          <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" fill="currentColor"/>
                          <path d="M20 4H16.83L15 2H9L7.17 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM20 18H4V6H8.05L9.88 4H14.12L15.95 6H20V18Z" fill="currentColor"/>
                        </svg>
                        Take Photo
                      </button>
                      
                      <input type="file" id="face-upload-input" accept="image/*" style="display: none;">
                      <button id="upload-btn" class="welcome-btn secondary consent-disabled" disabled type="button">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" style="margin-right: 6px;">
                          <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" fill="currentColor"/>
                        </svg>
                        Upload Photo
                      </button>
                    </div>

                    <button id="skip-scan-btn" class="link-btn" type="button">Skip for Now</button>
                  </div>
                </div>

                <!-- Camera State (Active) -->
                <div id="face-scan-camera" class="face-scan-step" style="display: none;">
                  <div class="face-scan-header">
                    <h3>AI Face Scan</h3>
                    <p>Ensure you are in a well-lit area for the best results.</p>
                  </div>
                  
                  <div id="camera-container">
                    <video id="camera-preview" autoplay playsinline></video>
                    <canvas id="photo-canvas" style="display: none;"></canvas>
                    <div id="camera-overlay">
                      <div class="face-outline"></div>
                    </div>
                    <div id="captured-image-container" style="display: none;">
                      <img id="captured-image" src="" alt="Captured face">
                    </div>
                  </div>

                  <!-- Status badge OUTSIDE circle - no overlap -->
                  <div class="face-status-badge">
                    <span class="dot"></span>
                    <span class="status-text">Positioning Face...</span>
                  </div>

                  <div class="face-scan-controls">
                    <div class="capture-actions side-by-side-buttons">
                      <button id="back-to-selection-btn" class="welcome-btn secondary">Back</button>
                      <button id="capture-btn" class="welcome-btn primary">Capture Photo</button>
                    </div>
                    <div class="confirm-actions" style="display: none;">
                      <button id="retake-btn" class="welcome-btn secondary">Retake</button>
                      <button id="confirm-scan-btn" class="welcome-btn primary">AI Analyze Now</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="chatbot-messages"></div>
            
            <div id="chatbot-input">
              <textarea placeholder="Type your message..." id="user-input" autocomplete="off" rows="1"></textarea>
              <button id="send-btn" title="Send">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z" fill="currentColor"/>
                </svg>
              </button>
            </div>
          </div>
          <div id="chatbot-products" style="display: none;"></div>
        </div>

        <!-- Guided Chat Transition Overlay -->
        <div id="chatbot-transition-overlay" style="display: none;">
          <div class="transition-content">
            <div class="transition-image-wrapper">
              <img id="transition-product-image" src="" alt="">
            </div>
            <div class="transition-spinner"></div>
            <p class="transition-text">Starting Guided Chat</p>
            <p class="transition-subtext" id="transition-product-name">Preparing recommendations...</p>
          </div>
        </div>

      </div>


    `;
  }

  function initChatbotDOM() {
    const existingWidget = document.getElementById('chatbot-widget');
    if (existingWidget) return existingWidget;

    const widget = document.createElement("div");
    widget.id = "chatbot-widget";
    widget.innerHTML = createWidgetHTML();
    const pageContainer = document.querySelector('.chatbot-page-container');
    if (window.CHATBOT_PAGE_MODE && pageContainer) {
      pageContainer.appendChild(widget);
    } else {
      document.body.appendChild(widget);
    }

    return widget;
  }

  function setHeaderTitle(text) {
    const span = document.querySelector('#chatbot-header-title span');
    if (span && text != null && String(text).length) span.textContent = text;
  }

  function getDOMReferences() {
    return {
      toggle: document.getElementById("chatbot-toggle"),
      box: document.getElementById("chatbot-box"),
      close: document.getElementById("chatbot-close"),
      expand: document.getElementById("chatbot-expand"),
      input: document.getElementById("user-input"),
      sendBtn: document.getElementById("send-btn"),
      messagesContainer: document.getElementById("chatbot-messages"),
      productsContainer: document.getElementById("chatbot-products"),
      welcomeScreen: document.getElementById("chatbot-welcome"),
      questionnaireContainer: document.getElementById("chatbot-questionnaire"),
      questionnaireContent: document.getElementById("questionnaire-content"),
      chatInput: document.getElementById("chatbot-input"),
      contentContainer: document.getElementById("chatbot-content-container"),
      mainPanel: document.getElementById("chatbot-main-panel"),
      startQuestionnaireBtn: document.getElementById("start-questionnaire-btn"),
      prevQuestionBtn: document.getElementById("prev-question-btn"),
      nextQuestionBtn: document.getElementById("next-question-btn"),
      progressFill: document.getElementById("progress-fill"),
      currentQuestionSpan: document.getElementById("current-question"),
      totalQuestionsSpan: document.getElementById("total-questions"),
      viewProductsBtn: document.getElementById("chatbot-view-products"),
      viewResultsHeaderBtn: document.getElementById("chatbot-view-results-header"),
      viewAnalysisBtn: document.getElementById("view-analysis-btn"),
      retakeTestWelcomeBtn: document.getElementById("retake-test-welcome-btn"),
      faceScanContainer: document.getElementById("chatbot-face-scan"),
      cameraPreview: document.getElementById("camera-preview"),
      photoCanvas: document.getElementById("photo-canvas"),
      captureBtn: document.getElementById("capture-btn"),
      retakeBtn: document.getElementById("retake-btn"),
      confirmScanBtn: document.getElementById("confirm-scan-btn"),
      capturedImageContainer: document.getElementById("captured-image-container"),
      capturedImage: document.getElementById("captured-image"),
      retakeTestBtn: document.getElementById("chatbot-retake-test"),
      uploadBtn: document.getElementById("upload-btn"),
      faceUploadInput: document.getElementById("face-upload-input"),
      backToResultsBtn: document.getElementById("chatbot-back-to-results"),
      startCamBtn: document.getElementById("start-camera-btn"),
      skipScanBtn: document.getElementById("skip-scan-btn"),
      backToSelectionBtn: document.getElementById("back-to-selection-btn"),
      consentCheckbox: document.getElementById("face-scan-consent-checkbox"),
      consentWrapper: document.getElementById("face-scan-consent-wrapper"),
      consentError: document.getElementById("face-scan-consent-error"),
      openPolicyBtn: document.getElementById("open-face-scan-policy-btn"),
      policyModal: document.getElementById("face-scan-policy-modal"),
      policyBackdrop: document.getElementById("face-scan-policy-backdrop"),
      closePolicyBtn: document.getElementById("close-face-scan-policy-btn"),
      dismissPolicyBtn: document.getElementById("dismiss-face-scan-policy-btn"),
      acceptPolicyBtn: document.getElementById("accept-face-scan-policy-btn"),
      transitionOverlay: document.getElementById("chatbot-transition-overlay"),
      transitionProductName: document.getElementById("transition-product-name"),
      transitionProductImage: document.getElementById("transition-product-image")
    };
  }

  // Expose public API
  window.ChatbotUI = {
    init: initChatbotDOM,
    getRefs: getDOMReferences,
    setHeaderTitle: setHeaderTitle,
    // Used by ai-skin-decode / landing pages.
    // We keep it simple by delegating to the existing toggle click handler.
    openChatbot: () => {
      const toggle = document.getElementById("chatbot-toggle");
      if (toggle) toggle.click();
    }
  };

})();
